export const DashboardDispatch = {
  title: 'Pedidos Expedidos'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/DashboardDispatch.js